<header id="header" class="header">
    <div class="container-fluid">
        <nav class="navbar fixed-top navbar-expand-lg bg-body-tertiary nav-bar-shadow">
            <div class="container justify-content-between">
                <a class="navbar-brand logo" routerLink="/">
                    <h1 class="sitename">AIO Invoice</h1>
                     <!-- <h1 class="sitename">
                        <span class="line-1">All-In-One</span>
                        <span class="line-2">Invoice</span>
                    </h1> -->
                </a>

                <div class="d-flex align-items-center ms-auto mobile-actions">
                    <!-- Login button (visible on mobile) -->
                    @if(!isAuthenticated()){
                        <a routerLink="/auth" class="btn-getstarted d-lg-none">Login</a>
                    }

                    @if(isAuthenticated()){
                        <div class="dropdown d-lg-none">
                                <button class="btn-getstarted dropdown-toggle" type="button" id="userMenuButton"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                    Account
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userMenuButton">
                                    <li>
                                        <a class="dropdown-item" routerLink="/dashboard"
                                            (click)="toggleNavbar()">Dashboard</a>
                                    </li>
                                    <li>
                                        <hr class="dropdown-divider">
                                    </li>
                                    <li>
                                        <button class="dropdown-item" type="button" (click)="logoutUser()" >Logout</button>
                                    </li>
                                </ul>
                            </div>
                    }

                    <!-- Toggle button -->
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                </div>
                
                <div class="collapse navbar-collapse" id="navbarSupportedContent" #myNav>
                    <ul class="navbar-nav ms-auto me-auto mb-2 mb-lg-0">
                        <li class="nav-item navmenu-item">
                            <a class="nav-link" aria-current="page" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" routerLink="/" (click)="toggleNavbar()">Home</a>
                        </li>
                        <li class="nav-item navmenu-item">
                            <a class="nav-link" routerLink="/about" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="toggleNavbar()">About</a>
                        </li>
                        <li class="nav-item navmenu-item">
                            <a class="nav-link" routerLink="/services" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="toggleNavbar()">Services</a>
                        </li>
                        <li class="nav-item navmenu-item">
                            <a class="nav-link" routerLink="/pricing" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="toggleNavbar()">Pricing</a>
                        </li>
                        <li class="nav-item navmenu-item">
                            <a class="nav-link " routerLink="/contact" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="toggleNavbar()">Contact</a>
                        </li>
                    </ul>
                    
                    @if(!isAuthenticated()){
                        <div class="d-none d-lg-flex align-items-center" >
                            <a routerLink="/auth" class="btn-getstarted" (click)="toggleNavbar()" routerLinkActive="activeBtnLink">Login</a>
                            <a routerLink="/invoice" class="btn-getstarted" (click)="toggleNavbar()" routerLinkActive="activeBtnLink">Free Invoice</a>
                        </div>
                    }

                    @if(!isAuthenticated()){
                        <div class="d-lg-none d-flex align-items-center" >
                            <a routerLink="/invoice" class="btn-getstarted" (click)="toggleNavbar()" routerLinkActive="activeBtnLink">Free Invoice</a>
                        </div>
                    }

                    @if(isAuthenticated()){
                        <div class="d-none d-lg-flex align-items-center">
                            <div class="dropdown">
                                <button class="btn-getstarted dropdown-toggle" type="button" id="userMenuButton"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                    Account
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userMenuButton">
                                    <li>
                                        <a class="dropdown-item" routerLink="/dashboard"
                                            (click)="toggleNavbar()">Dashboard</a>
                                    </li>
                                    <li>
                                        <hr class="dropdown-divider">
                                    </li>
                                    <li>
                                        <button class="dropdown-item" type="button" (click)="logoutUser()" >Logout</button>
                                    </li>
                                </ul>
                            </div>
                            <a routerLink="/invoice" class="btn-getstarted" (click)="toggleNavbar()" routerLinkActive="activeBtnLink">Invoice</a>
                        </div>
                    }
                </div>
            </div>
        </nav>
    </div>
</header>